export enum EListingTileTagSlug {
  Superhost = 'superhost',
  GuestFavorite = 'guest-favorite',
}
